import { passCodes } from '../passCodes';

export const step18riddle = {
    id: 18,
    title: 'Vyšetřování',
    taskText: `
        <p>
            Odpovězte správně na všechny otázky a procvičte si mysl.
        </p>
    `,
    cipher: {
        text: `
            <p>
                Jakou barvu má střecha kopule na kostele?
            </p>
            <ol type="a">
                <li>žlutá</li>
                <li>červená</li>
                <li>zelená</li>
            </ol>
        `,
        label: 'Úkol',
    },
    codeInputText: ' ',
    codeInputPassCodeRegexp: passCodes[6],
    additionalInfo: 'Odpovědí je písmeno a/b/c',
    points: false,
    hints: [
        {
            text: 'Střecha je zelená',
        },
    ],
};
